module.exports = __webpack_public_path__ + "media/slide3/contractMediaSlide3Part1-6f6198df.png";